var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stock-logo"},[(!_vm.hasError)?_c('img',{attrs:{"src":_vm.logoUrl,"alt":_vm.stockName},on:{"error":_vm.handleError}}):_c('span',{staticClass:"stock-logo__placeholder"},[_vm._v(_vm._s(_vm.placeholderText))])])}
var staticRenderFns = []

export { render, staticRenderFns }